import {getInitialData, resetContainers, clearDynamicContainer, toggleSidePanel, dynamicContainer, scwFetch} from '../main';
import { broadcastSsoStateChange } from '../utils/broadcast';
import { onClick } from '../utils/form';

interface UserVerificationState {
    actionURL: string;
    verificationToken: string
}

interface UserVerificationResponse {
    isValid?: boolean;
}

const state = getInitialData<UserVerificationState>();

const templates = {
    userVerification: document.getElementById("template_userVerification") as HTMLTemplateElement,
    userVerificationComplete: document.getElementById("template_userVerificationComplete") as HTMLTemplateElement,
};

const templateContainer = templates.userVerification?.content?.cloneNode(true) as DocumentFragment;
    resetContainers();
    clearDynamicContainer();
    toggleSidePanel(true);

    const submitButton = templateContainer.querySelector('button[data-scw-verify-email="true"]') as HTMLButtonElement;

    onClick(submitButton, async () => {
        const response = await scwFetch<UserVerificationResponse>("/api/user-verification/" + state.verificationToken, {
            method: "POST",
        });

        if (response && response.isValid) {
            const userVerificationCompleteTemplateContainer = templates.userVerificationComplete?.content?.cloneNode(true) as DocumentFragment;
            broadcastSsoStateChange({
                action: 'SSO_REDIRECT_TO_TOOL',
                payload: {url: state.actionURL}
            });
            clearDynamicContainer();
            dynamicContainer.append(userVerificationCompleteTemplateContainer);
        }
    });

    dynamicContainer.append(templateContainer);